import { useEffect } from "react";

import { constants } from "../config/constants";
import { createState } from "../store/zustand_store";
import { useTeamConfig } from "../hooks/useTeamConfig";
import { useStorageCache } from "../hooks/useStorageCache";
import { useRouterExtended } from "../hooks/useRouterExtended";

export interface InfoFields {
  name: string;
  value: string;
  info_field: number;
}

export const useInfoFields = createState<{ infoFields: InfoFields[] }>({
  infoFields: [],
});

export function InfoFieldsContainer() {
  const { set } = useInfoFields();
  const { query } = useRouterExtended();
  const { teamSchema, infoFieldsConfig } = useTeamConfig();

  const infoFieldsStorage = useStorageCache(constants.infoFieldsStorageKey);
  const storageInfoFields = infoFieldsStorage?.get(teamSchema) as InfoFields[];

  function getInfoField(name: string) {
    return storageInfoFields?.find((item) => item.name === name)?.value;
  }

  useEffect(() => {
    const infoFields: InfoFields[] = [];

    if (infoFieldsConfig) {
      Object.entries(infoFieldsConfig).forEach(([key, config]) => {
        if (config) {
          const storageValue = getInfoField(key);
          const queryValue = query?.[key] as string;
          const fieldValue = queryValue || storageValue;

          if (fieldValue) {
            infoFields.push({
              info_field: config.infoField,
              value: fieldValue,
              name: config.name,
            });
          }
        }
      });
    }

    infoFieldsStorage?.set(teamSchema, infoFields);
    set({ infoFields });
  }, []);

  return null;
}
